import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrainingRecorderComponent } from './training-recorder.component';



@NgModule({
  declarations: [TrainingRecorderComponent],
  imports: [
    CommonModule
  ],
  exports: [TrainingRecorderComponent]
})
export class TrainingRecorderModule { }
